import React, { useEffect, useState } from "react";
import { useRouteError } from "react-router-dom";

import { Container, Card, Message, StyledButton, Title } from "./ErrorPage.style";
import { useTranslation } from "react-i18next";
import { isChunkLoadError, reloadOnceForChunkError } from "utils/chunkLoadError";

export const ErrorPage = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  const isChunkError = isChunkLoadError(error);
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    if (isChunkError && reloadOnceForChunkError()) {
      setIsReloading(true);
    }
  }, [isChunkError]);

  // Reload is in flight (page is about to hard-navigate) — avoid flashing the full error card.
  if (isReloading) {
    return null;
  }

  return (
    <Container>
      <Card>
        <Title>{t("ErrorPage.Title")}</Title>
        <Message>{t("ErrorPage.Description")}</Message>
        <StyledButton
          data-heap="error-page-reload-button"
          title={t("ErrorPage.Button.Text")}
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("ErrorPage.Button.Text")}
        </StyledButton>
      </Card>
    </Container>
  );
};

export default ErrorPage;
